import { Typography } from "@suraasa/placebo-ui"
import {
  Button,
  Theme,
  Tooltip,
  useMediaQuery,
} from "@suraasa/placebo-ui-legacy"
import clsx from "clsx"
import React from "react"
import { createUseStyles, useTheme } from "react-jss"

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    backgroundColor: theme.colors.highlight[500],
    borderRadius: 8,
    boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.05)",
    padding: theme.spacing(3, 4),
    [theme.breakpoints.down("xs")]: {
      borderRadius: 0,
    },
  },
}))

const ResumeAssessmentBanner = ({
  timer,
  disabledReason,
  onResume,
  isOlympiad,
  attemptInProgress,
}: {
  timer?: JSX.Element
  attemptInProgress: boolean
  isOlympiad: boolean
  disabledReason: string
  onResume: () => void
}) => {
  const action = attemptInProgress ? "Resume" : "Start"
  const testName = isOlympiad ? "Olympiad" : "Assessment"
  const description = attemptInProgress
    ? `You have already started the ${testName}, finish before time runs out.`
    : "Good luck!"

  const theme = useTheme<Theme>()
  const classes = useStyles()
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"))

  return (
    <button
      className={clsx(
        classes.container,
        "mb-3 mt-2 grid w-full grid-flow-row items-center gap-2 text-start md:grid-flow-col md:justify-between md:gap-0"
      )}
      disabled={Boolean(disabledReason)}
      onClick={onResume}
    >
      <div>
        <Typography variant="title3" className="pb-0.25 text-white">
          {action} the {testName}
        </Typography>
        <Typography className="text-white">{description}</Typography>
      </div>

      {/* This div is important for alignment */}
      <div>
        <Tooltip title={disabledReason} disabled={!disabledReason}>
          <div>
            <Button
              disabled={Boolean(disabledReason)}
              color="black"
              style={{ color: theme.colors.highlight[500] }}
              fullWidth={isSmDown}
              onClick={onResume}
            >
              {action} {testName}
            </Button>
            {timer}
          </div>
        </Tooltip>
      </div>
    </button>
  )
}

export default ResumeAssessmentBanner
